import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';
import { changesSection } from './changes';

const noticeTo = c.mailingAddress ? `${c.supportEmail} or by mail to ${c.mailingAddress}` : c.supportEmail;

export const legalNotice: PolicyDocument = {
  title: 'Legal Notice',
  lead: `Legal information about ${c.website} and the ${c.brand} brand.`,
  sections: [
    {
      id: 'operator',
      heading: '1. Website operator',
      blocks: [
        `This website, ${c.website}, is operated under the trade name ${c.brand} ("${c.brand}", "we", "us"). All sales are made by ${c.brand} in accordance with our Terms of Service.`,
      ],
    },
    {
      id: 'notices',
      heading: '2. How to send a legal notice',
      blocks: [
        `All legal notices, notices of dispute, demand letters and requests related to our Terms of Service must be sent in writing to ${noticeTo}, with the subject line "Legal Notice". Notices must include your full name, contact information, order number (if applicable), and a detailed description of the matter and the relief requested.`,
        'Notices sent by phone, text message, social media, product reviews, chat, or to any other address are not valid notice. A notice is considered received only when we confirm receipt in writing.',
        'Sending a notice of dispute is required before starting any arbitration or claim, as described in the Binding Arbitration section of our Terms of Service.',
      ],
    },
    {
      id: 'ip',
      heading: '3. Trademarks and copyright',
      blocks: [
        `${c.brand}, MarineForce, M1 PRO, Magnetic Mount System, the trident logo, and related names, logos, slogans and product designs are trademarks or trade dress of ${c.brand}. All website content — including text, graphics, photographs, videos, animations, illustrations, product images, page layouts and software — is the property of ${c.brand} or its licensors and is protected by U.S. and international copyright, trademark and other intellectual property laws.`,
        `You may not copy, reproduce, republish, download, modify, distribute, sell, use in advertising, or create derivative works from any part of this website without our prior written permission. Unauthorized use of our names, images or product designs — including on marketplaces, social media or in advertisements — is prohibited and may result in legal action.`,
        'Other company names, product names and logos shown on this website, including payment and shipping carrier logos, are the property of their respective owners and are used for identification only. Their use does not imply endorsement.',
      ],
    },
    {
      id: 'dmca',
      heading: '4. Copyright complaints (DMCA)',
      blocks: [
        `If you believe content on this website infringes your copyright, send a notice to ${c.supportEmail} with the subject "DMCA Notice" that includes: (a) your physical or electronic signature; (b) identification of the copyrighted work; (c) identification of the allegedly infringing material and where it appears on our website; (d) your contact information; (e) a statement that you have a good-faith belief the use is not authorized by the copyright owner, its agent or the law; and (f) a statement, under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorized to act on the owner's behalf.`,
      ],
    },
    {
      id: 'resellers',
      heading: '5. Authorized sellers',
      blocks: [
        `${c.brand} products are sold only through ${c.website} and our official checkout. We do not authorize any other seller, marketplace listing or website. Products purchased from unauthorized sellers are not covered by our Limited Warranty, and we are not responsible for counterfeit or misrepresented products.`,
      ],
    },
    {
      id: 'content',
      heading: '6. Website content',
      blocks: [
        'Information on this website is provided for general information about our products and may be changed, updated or removed at any time without notice. Product images, illustrations, renderings and lifestyle scenes are for illustrative purposes. Nothing on this website is professional installation, electrical, pool, marine or safety advice.',
        'We are not responsible for the content, privacy practices or availability of third-party websites linked from this website, including payment, shipping and social-media services.',
      ],
    },
    {
      id: 'terms',
      heading: '7. Governing terms',
      blocks: [
        `Use of this website and all purchases are governed by our Terms of Service, including the limitation of liability, binding individual arbitration and class action waiver, and the laws of the State of ${c.governingState}. Our Privacy Policy, Warranty Information, Return & Refund Policy, Shipping Policy and Product Safety & Use page form part of those Terms.`,
      ],
    },
    changesSection('Legal Notice', '8. Changes to this notice'),
  ],
};
